import React, { useCallback, useMemo } from "react";
import { Card, Col, Pagination, Row } from "react-bootstrap";
import { PAGE_GAP } from "../../../constants";

export default function PaginationBar({ pageNumbers, currentPage, totalPages, onNavigate }) {
  const handlePageItemClick = useCallback((event) => {
    onNavigate(Number(event.currentTarget.dataset.page));
  }, [onNavigate]);

  const handleFirstPage = useCallback(() => onNavigate(1), [onNavigate]);
  const handlePrevPage = useCallback(() => onNavigate(currentPage - 1), [onNavigate, currentPage]);
  const handleNextPage = useCallback(() => onNavigate(currentPage + 1), [onNavigate, currentPage]);
  const handleLastPage = useCallback(() => onNavigate(totalPages), [onNavigate, totalPages]);

  const pageItems = useMemo(() => {
    return Array.from(pageNumbers, (item) =>
      item === PAGE_GAP ? (
        <Pagination.Ellipsis key={Math.random()} disabled />
      ) : (
        <Pagination.Item key={item} active={item === currentPage} data-page={item} onClick={handlePageItemClick}>
          {item}
        </Pagination.Item>
      )
    );
  }, [pageNumbers, currentPage, handlePageItemClick]);

  return (
    <Row className="m-0 mt-3">
      <Col className="p-0">
        <Card className="border-0 shadow-sm bg-white p-3 d-flex align-items-center justify-content-center">
          <Pagination className="m-0 p-0">
            <Pagination.First disabled={currentPage === 1} onClick={handleFirstPage} />
            <Pagination.Prev disabled={currentPage === 1} onClick={handlePrevPage} />
            {pageItems}
            <Pagination.Next disabled={currentPage === totalPages} onClick={handleNextPage} />
            <Pagination.Last disabled={currentPage === totalPages} onClick={handleLastPage} />
          </Pagination>
        </Card>
      </Col>
    </Row>
  );
}
